// Must be evaluated before the video.js module is imported: suppresses video.js's
// runtime injection of inline <style> elements, which violates CSP style-src 'self'.
// Sized by CSS (components/video.scss), not by video.js dynamic styles.
window.VIDEOJS_NO_DYNAMIC_STYLE = true;